<!-- <div class="cash_header_calc_box">

    <table style="height: 100%; width: 100%;">
        <tr style="border: 1px solid #000">
            <td class="cash_type_td">
                <div class="cash_type_td_div" style="height: 66.66%;">
                    <div class="centarised-div-label">BILL AMOUNT</div>
                </div>
                <div class="cash_row_value">
                    <div class="centarised-div-value">{{total_bill_amt | number : '1.0-2'}}</div>
                </div>
            </td>
            <td class="cash_type_td">
                <div class="cash_type_td_div">
                    <img class="centarised-div-label" async src="./assets/images/cashw.svg" alt="icon" />
                </div>
                <div class="cash_type_td_div">
                    <div class="centarised-div-label">CASH</div>
                </div>
                <div class="cash_row_value">
                    <div class="centarised-div-value">{{total_amt_cash | number : '1.0-2'}}</div>
                </div>
            </td>
            <td class="cash_type_td">
                <div class="cash_type_td_div">
                    <img class="centarised-div-label" async src="./assets/images/upiw.svg" alt="icon" />
                </div>
                <div class="cash_type_td_div">
                    <div class="centarised-div-label">UPI</div>
                </div>
                <div class="cash_row_value">
                    <div class="centarised-div-value">{{total_amt_upi | number : '1.0-2'}}</div>
                </div>
            </td>
            <td class="cash_type_td">
                <div class="cash_type_td_div">
                    <img class="centarised-div-label" async src="./assets/images/chequew.svg" alt="icon" />
                </div>
                <div class="cash_type_td_div">
                    <div class="centarised-div-label">BANK</div>
                </div>
                <div class="cash_row_value">
                    <div class="centarised-div-value">{{total_amt_bank | number : '1.0-2'}}</div>
                </div>
            </td>
            <td class="cash_type_td">
                <div class="cash_type_td_div">
                    <img class="centarised-div-label" async src="./assets/images/coupon.svg" alt="icon" />
                </div>
                <div class="cash_type_td_div">
                    <div class="centarised-div-label">COUPON</div>
                </div>
                <div class="cash_row_value">
                    <div class="centarised-div-value">{{total_amt_coupon | number : '1.0-2'}}</div>
                </div>
            </td>
            <td class="cash_type_td">
                <div class=" cash_type_td_div">
                    <img class="centarised-div-label" async src="./assets/images/cardw.svg" alt="icon" />
                </div>
                <div class="cash_type_td_div">
                    <div class="centarised-div-label">CARD</div>
                </div>
                <div class="cash_row_value">
                    <div class="centarised-div-value">{{total_amt_card | number : '1.0-2'}}</div>
                </div>
            </td>
        </tr>
    </table>
</div> -->

<div class="payment_tab_container">
    <div style="height: 6%;">
        <div class="header_div">
            <span class="header_div_data">PAY Rs : {{total_bill_amt | number : '1.0-2'}}</span>
        </div>
    </div>
    <mat-tab-group (selectedTabChange)="tabClicked($event)" [(selectedIndex)]="selectedIndex" mat-stretch-tabs class="tab_group" style="height: 86%;">
        <form [formGroup]="createCollectionForm">
            <!-- CASH -->
            <mat-tab label="CASH">
                <ng-template mat-tab-label>
                    <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/cashn.svg" alt="icon" />
                        <!-- <span>CASH</span> -->
                    <span class="img_span">&#8377; {{total_amt_cash | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div ng-controller="cashtabController" style="height: 100%; overflow: hidden;" class="ng-scope cashTab" id="cashTab">
                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="balance < 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number : '1.0-2'}}
                                    </div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{balance | absolute}}</div>

                                    <!-- <div class="curr_amt_label" *ngIf="refundAmt === 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="refundAmt > 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="refundAmt === 0">&#8377; {{balance | number : '1.0-2'}}</div>
                                    <div class="curr_amt_value" *ngIf="refundAmt > 0">&#8377; {{refundAmt | absolute}}</div> -->

                                    <!-- <div class="curr_amt_value" *ngIf="refundAmt > 0"
                                        style="width: 75px !important;padding: 0px !important;"><input
                                            style="padding-left: 10px !important;" type="number"
                                            (keyup)="onRefundAmtChange($event)" [value]="refundAmt"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="amt_suggest_box_row_cash">
                        <table class="full_width_table">
                            <tr class="cash_tr">
                                <td class="cash_td" style="width: 100%;">
                                    <div class="amt_container">
                                        <div class="group_amt">
                                            <input type="text" style="padding: 10px;" required="required" formControlName="cashAmount" onkeypress='return event.charCode >= 48 && event.charCode <= 57' (keyup)="onCashAmountChange($event)" />
                                            <span class=" highlight "></span><span class="bar "></span>
                                            <label class="amtLabel ">Amount</label>
                                        </div>
                                    </div>
                                </td>

                                <td ng-show="sug1" *ngFor="let deno of sortedAmt" class="cash_td">
                                    <div class="amt_container">
                                        <div class="group_amt">
                                            <div class="btn-box">
                                                <button mat-button class="md-raised md-primary" id="btn-amt-blue" (click)="getAmount(deno)" *ngIf="deno == balance">
                                                    <span style="display: flex; justify-content: center;">
                                                        <span
                                                            style="font-size: 9px; position: absolute; top: -12px;">Exact
                                                            Tender</span>
                                                        <span style="font-size: 17px; margin-top: 5px;">&#8377;
                                                            {{deno}}</span>
                                                    </span>
                                                </button>

                                                <button mat-button class="md-raised md-primary" id="btn-amt-grey" (click)="getAmount(deno)" *ngIf="deno != balance">
                                                    <span style="display: flex; justify-content: center;">
                                                        <span
                                                            style="font-size: 9px; position: absolute; top: -12px;">Tender</span>
                                                        <span style="font-size: 17px; margin-top: 5px;">&#8377;
                                                            {{deno}}</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetCash()">RESET </button>
                        <button mat-button id="btnn" style="float: right;" (click)="onCashPaymentOkClick()">OK</button>
                    </div>
                </div>
            </mat-tab>

            <!-- UPI -->
            <mat-tab label="UPI">
                <ng-template mat-tab-label>
                    <!-- <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/upiw.svg" alt="icon" />
                        <span>UPI ({{total_amt_upi | number : '1.0-2'}})</span>
                    </span> -->

                    <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/upin.svg" alt="icon" />
                        <!-- <span>UPI</span> -->
                    <span class="img_span">&#8377; {{total_amt_upi | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div class="coupon_main_container" ng-controller="upitabController">
                    <div class="curr_bal_row" style="height: 18%;">
                        <div class="balance_container" style="height: 50%;">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="balance < 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number : '1.0-2'}}
                                    </div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{balance | absolute}}</div>

                                    <!-- <div class="curr_amt_label" *ngIf="returnAmt === 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="returnAmt > 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="returnAmt === 0">&#8377; {{balance | number : '1.0-2'}}</div>
                                    <div class="curr_amt_value" *ngIf="returnAmt > 0">&#8377; {{returnAmt | absolute}}</div> -->
                                    <!-- <div class="curr_amt_value" *ngIf="refundAmt > 0"
                                        style="width: 75px !important;padding: 0px !important;"><input
                                            style="padding-left: 10px !important;" type="number"
                                            (keyup)="onRefundAmtChange($event)" [value]="refundAmt"></div> -->
                                </div>
                            </div>
                        </div>

                        <div class="balance_container" style="height: 50%;padding: 0 10px;">
                            <div class="amt_card_div" style="width: 99%;">
                                <mat-card class="contain_card" style="width: 100%;">
                                    <mat-form-field class="field-full-width">
                                        <mat-select placeholder="Select Payment Mode" formControlName="upiPaymentMode" (selectionChange)="onUpiPaymentModeSelect($event.value)">
                                            <mat-option *ngFor="let comp of upiPaymentModeList" [value]="comp">
                                                {{comp}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                    <!-- UPI Type -->
                    <div *ngIf="upiPaymentMode == 'ICICI'" formArrayName='upiPayment' class="body_coupon_cash" style="height: 70%;">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 84px;">

                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 86%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Customer Name" [value]="UpiCustomerName" readonly>
                                        </mat-form-field>
                                    </mat-card>
                                    <!-- <div class="create_customer"> -->
                                    <button mat-button class="create_cust_btn" *ngIf="!isUpiSelectedCustomer" (click)="onUpiSelectCustomerClick()" style="height: 36px;">
                                        <mat-icon class="personadd_icon">person_add</mat-icon>
                                    </button>

                                    <button mat-button class="customer_close" *ngIf="isUpiSelectedCustomer" (click)="onRemoveUpiCustomerClick()" style="height: 36px;">
                                        <mat-icon class="white_icon_cancel_customer">close</mat-icon>
                                    </button>
                                    <!-- </div> -->
                                </div>

                                <div class="amt_card_div" ng-class="{ 'error_border':upiForm.mobile_number.$error.pattern}">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Customer Mobile" [value]="UpiCustomerMobileNo">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>

                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Amount To Pay" [value]="upi_amount_to_pay" (keyup)="onUpiAmountChange($event)">
                                        </mat-form-field>
                                    </mat-card>
                                </div>

                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Payer Va" (keyup)="onPayeeVaChange($event)">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 33px; display: flex; justify-content: space-evenly;">
                            <button mat-button id="btnn" style="float: left; width: 48%; margin: 0 !important; height: 100%;" (click)="generateQRCode() ">QR Code</button>

                            <button mat-button id="btnn" style="float: left; width: 48%; margin: 0 !important; height: 100%;" type="submit" (click)="sendCollectPayRequest()">Collect Pay</button>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 148px; display: flex; justify-content: center; margin: 8px 0px;">
                            <div ng-show="qrloading" class="qrCode_container_upi" style="width: 150px;">
                                <div class="qrCodeContainerbox">
                                    <p *ngIf="showQrCodeLabel" class="qrCodeLabel">
                                        Select Customer.<br>Enter Amount.<br>Generate QR Code.
                                    </p>
                                    <qrcode *ngIf="showQrCode" [qrdata]="generatedQRCode" [width]="148" [errorCorrectionLevel]="'M'">
                                    </qrcode>
                                </div>
                            </div>
                        </div>

                        <div *ngFor="let upi of upiPaymentFormArray.controls; let i=index" [formGroupName]="i" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field style="width: 70%;">
                                            <input type="text" matInput placeholder="Status" readonly>
                                        </mat-form-field>
                                        <mat-slide-toggle style="width: 30%;" (change)="changeUpiStatus()" formControlName="transStatus" [checked]="status">
                                        </mat-slide-toggle>
                                    </mat-card>
                                </div>

                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field style="width: 82%;">
                                            <input type="text" matInput placeholder="Transaction ID" [value]="merchantTranId" formControlName="merchantTranId">
                                        </mat-form-field>
                                        <!-- <mat-icon style="width: 18%;" (click)="onFetchPaymentClick()">refresh</mat-icon> -->
                                    </mat-card>
                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Payment Address" [value]="payerVA" formControlName="payerVA">
                                        </mat-form-field>
                                    </mat-card>

                                </div>

                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Amount" [value]="transAmt" formControlName="transAmt">
                                        </mat-form-field>
                                    </mat-card>

                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Bank Reference No. " [value]="originalBankRRN" formControlName="bankRRN">
                                        </mat-form-field>
                                    </mat-card>
                                </div>

                                <div class="amt_card_div" id="edit_search_label">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Date " [value]="txnCompletionDate" formControlName="transDate">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="upiPaymentMode == 'ICICI'" class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetUpi()"> RESET</button>
                        <button mat-button id="btnn" style="float:right;" (click)="onUpiPaymentOkClick() ">OK</button>
                    </div>

                    <!-- Paytm Type -->
                    <div *ngIf="upiPaymentMode == 'PAYTM'" formArrayName='paytmPayment' class="body_coupon_cash" style="height: 70%;">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 84px;">

                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 86%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Customer Name" [value]="PaytmCustomerName" readonly>
                                        </mat-form-field>
                                    </mat-card>
                                    <!-- <div class="create_customer"> -->
                                    <button mat-button class="create_cust_btn" *ngIf="!isPaytmSelectedCustomer" (click)="onPaytmSelectCustomerClick()" style="height: 36px;">
                                        <mat-icon class="personadd_icon">person_add</mat-icon>
                                    </button>

                                    <button mat-button class="customer_close" *ngIf="isPaytmSelectedCustomer" (click)="onRemovePaytmCustomerClick()" style="height: 36px;">
                                        <mat-icon class="white_icon_cancel_customer">close</mat-icon>
                                    </button>
                                    <!-- </div> -->
                                </div>

                                <div class="amt_card_div" ng-class="{ 'error_border':upiForm.mobile_number.$error.pattern}">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Customer Mobile" [value]="PaytmCustomerMobileNo">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>

                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Amount To Pay" [value]="paytm_amount_to_pay" (keyup)="onPaytmAmountChange($event)">
                                        </mat-form-field>
                                    </mat-card>
                                </div>

                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Message/Link Description " (keyup)="onMessageLinkDescChange($event) ">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 33px; display: flex; justify-content: space-evenly;">
                            <button mat-button id="btnn" style="float: left; width: 48%; margin: 0 !important; height: 100%;" (click)="generatePaytmQRCode()">QR Code</button>

                            <button mat-button id="btnn" style="float: left; width: 48%; margin: 0 !important; height: 100%;" type="submit" (click)="sendPaymtmCollectPayRequest()">Collect Pay</button>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 166px; display: flex; justify-content: center; margin: 8px;">
                            <div ng-show="qrloading" class="qrCode_container_upi">
                                <div class="qrCodeContainerbox">
                                    <p *ngIf="showQrCodeLabelPaytm" class="qrCodeLabel">
                                        Select Customer.<br>Enter Amount.<br>Generate QR Code.
                                    </p>
                                    <qrcode *ngIf="showQrCodePaytm" [qrdata]="generatedQRCodePaytm" [width]="173" [errorCorrectionLevel]="'M'">
                                    </qrcode>
                                </div>
                            </div>
                        </div>

                        <div *ngFor="let paytm of paytmPaymentFormArray.controls; let i=index" [formGroupName]=" i" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field style="width: 70%;">
                                            <input type="text" matInput placeholder="Status" readonly>
                                        </mat-form-field>
                                        <mat-slide-toggle style="width: 30%;" (change)="changeUpiStatus()" formControlName="transStatus" [checked]="statusPaytm">
                                        </mat-slide-toggle>
                                    </mat-card>
                                </div>

                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field style="width: 82%;">
                                            <input type="text" matInput placeholder="Order ID" formControlName="orderId">
                                        </mat-form-field>
                                        <!-- <mat-icon style="width: 18%;" (click)="onFetchPaymentClick()">refresh</mat-icon> -->
                                    </mat-card>
                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Mobile No./Paytm Id" formControlName="linkId">
                                        </mat-form-field>
                                    </mat-card>

                                </div>

                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Amount" formControlName="amount">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="amt_card_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Date">
                                        </mat-form-field>
                                    </mat-card>
                                </div>

                                <!-- <div class="amt_card_div" id="edit_search_label">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Date " [value]="txnCompletionDate"
                                                formControlName="transDate">
                                        </mat-form-field>
                                    </mat-card>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div *ngIf="upiPaymentMode == 'PAYTM'" class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetPaytm()"> RESET</button>
                        <button mat-button id="btnn" style="float:right;" (click)="onPaytmPaymentOkClick() ">OK</button>
                    </div>
                </div>

            </mat-tab>

            <!-- SWIPE -->
            <mat-tab label="SWIPE">
                <ng-template mat-tab-label>
                    <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/swipep.svg" alt="icon" width="17"
                            height="20" />
                        <!-- <span>S</span> -->
                    <span class="img_span">&#8377; {{total_amt_swipe | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div class="coupon_main_container" ng-controller="upitabController">
                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="balance < 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number : '1.0-2'}}
                                    </div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{balance | absolute}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="body_coupon_cash">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 84px;">

                            <div class="amt_container">
                                <div class="amt_card_pg_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Amount To Pay" formControlName="swipeAmount" (keyup)="onSwipeAmountChange($event)">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 33px; display: flex; justify-content: space-evenly;">
                                <button mat-button id="btnn" style="float: left; width: 48%; margin: 0 !important; height: 100%;" (click)="sendPaymentRequestToEDC()">Send Request</button>

                                <button *ngIf="enableFetchSwipeBtn" mat-button id="btnn" style="float: left; width: 48%; margin: 0 !important; height: 100%;" type="button" (click)="checkPayTmPaymentStatus()">Fetch Reponse</button>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 33px; display: flex; justify-content: space-evenly;margin-top: 4%;">
                                <h4 style="font-size: 25px" [style.color]="paytmPaymentStatus == 'PAMENT INITIATED' ? '#ef8b09' : paytmPaymentStatus == 'TRANSACTION PENDING' ? '#ef8b09'
                                     : paytmPaymentStatus == 'TRANSACTION SUCCESS' ? 'green' : 'red'">
                                    {{paytmPaymentStatus}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetSwipe()"> RESET</button>
                        <button *ngIf="paytmPaymentStatus == 'TRANSACTION SUCCESS'" mat-button id="btnn" style="float:right;" (click)="onSwipePaymentOkClick()">OK</button>
                    </div>
                </div>
            </mat-tab>

            <!-- COUPON -->
            <mat-tab label="COUPON" *ngIf="dialogData.trnsactionDto?.couponPaymentAllowed">
                <ng-template mat-tab-label>
                    <!-- <span class="tab_head">
                                    <img class="img_div_height" async src="./assets/images/coupon.svg" alt="icon" />
                                    <span>COUPON ({{total_amt_coupon | number : '1.0-2'}})</span>
                                </span> -->

                    <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/couponn.svg" alt="icon" />
                        <!-- <span>COUPON</span> -->
                    <span class="img_span">&#8377; {{total_amt_coupon | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div class="coupon_main_container" ng-controller="coupontabController">
                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <!-- <div class="curr_amt_label" *ngIf="balance < 0">Refund</div> -->
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number : '1.0-2'}}
                                    </div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{0 | absolute}}</div>
                                    <!-- <div class="curr_amt_value" *ngIf="refundAmt > 0"
                                                    style="width: 75px !important;padding: 0px !important;"><input
                                                        style="padding-left: 10px !important;" type="number"
                                                        (keyup)="onRefundAmtChange($event)" [value]="refundAmt"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="height: 77%; overflow: auto;">
                        <div class="body_couponBank" formArrayName='couponPayment' style="height: 80% !important;">
                            <div *ngFor="let coupon of couponPaymentFormArray.controls; let i=index" [formGroupName]="i">
                                <span class="close_icon_span" style="float: left;">
                                    <mat-icon class="close_icon" *ngIf="!coupon.show"
                                        (click)="coupon.show = !coupon.show">keyboard_arrow_up</mat-icon>
                                    <mat-icon class="close_icon" *ngIf="coupon.show"
                                        (click)="coupon.show = !coupon.show">keyboard_arrow_down</mat-icon>
                                </span>
                                <span class="close_icon_span">
                                    <mat-icon class="close_icon" (click)="deleteCoupon(i)">delete</mat-icon>
                                </span>
                                <fieldset class="field_set" id="security_fieldset" style="padding-top: 20px;">
                                    <div *ngIf="!coupon.show">

                                        <mat-card class="contain_card">
                                            <mat-form-field style="width: 90%;">
                                                <input type="text" matInput placeholder="Coupon Code" formControlName="couponCode" (keyup)="onCouponCodeChange($event.target.value,i)">
                                            </mat-form-field>
                                            <mat-icon *ngIf="couponAmount[i]==0" style="color: red;">warning</mat-icon>
                                            <mat-icon *ngIf="couponAmount[i]>0" style="color: green;">done</mat-icon>
                                        </mat-card>

                                        <mat-card *ngIf="couponAmount[i]==0" class="contain_card" style="background: red !important;">
                                            <mat-form-field style="text-align: center;">
                                                <input type="text" matInput readonly>
                                                <mat-placeholder style="color: white;font-weight: bold;">INVALID COUPON
                                                </mat-placeholder>
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card *ngIf="couponAmount[i]>0" class="contain_card" style="background: green !important;">
                                            <mat-form-field style="text-align: center;">
                                                <input type="text" matInput readonly>
                                                <mat-placeholder style="color: white;font-weight: bold;">VALID COUPON
                                                </mat-placeholder>
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card *ngIf="couponAmount[i]==undefined" class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput readonly>
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="Amount" formControlName="couponAmount" (keyup)="onCouponAmountChange($event)" readonly>
                                            </mat-form-field>
                                        </mat-card>
                                        <!-- <div class="close_btn_div" fxFlex="4">
                                                        <button mat-button class="mat-icon-button md-accent close_btn_container"
                                                            (click)="deleteCoupon(i)" aria-label="Favorite">
                                                            <mat-icon class="close_icon">close</mat-icon>
                                                        </button>
                                                    </div> -->

                                    </div>
                                </fieldset>
                            </div>

                            <div class="bottom_btns_row_bank coupon_footer_mainDiv">
                                <div class="bottom_btns_row_col_6_div">
                                    <table class="bottom_btns_row_col_6_div_table">
                                        <tr class="coupon_total_bottom">
                                            <td>
                                                <div class="incentives_row_table_div_table_td_div_tr_td_div">Total Coupon
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="coupon_total_bottom">
                                            <td class="bottom_btns_row_col_6_div_table_td">
                                                <div class="incentives_row_table_div_table_td_div_tr_td_div">
                                                    {{totalCouponAmount}}
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="bottom_btns_row_col_6_div">
                                    <table class="bottom_btns_row_col_6_div_table">
                                        <tr class="coupon_total_bottom ">
                                            <td>
                                                <div class="incentives_row_table_div_table_td_div_tr_td_div">Total Amount
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="coupon_total_bottom">
                                            <td class="bottom_btns_row_col_6_div_table_td">
                                                <div class="incentives_row_table_div_table_td_div_tr_td_div">
                                                    &#8377;{{total_amt_coupon | number : '1.0-2'}}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetCoupon()">RESET </button>
                        <button mat-button id="btnn" style="float:right" (click)="onCouponPaymentOkClick()">OK</button>
                        <button mat-button id="btnn" style="float:right" (click)="addCoupon()" [disabled]="couponPaymentFormArray.invalid">
                            ADD COUPON</button>
                    </div>

                </div>
            </mat-tab>

            <!-- GATEWAY -->
            <mat-tab label="GATEWAY">
                <ng-template mat-tab-label>
                    <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/gatewayp.svg" alt="icon" width="25"
                            height="20" />
                        <!-- <span>G</span> -->
                    <span class="img_span">&#8377; {{total_amt_gateway | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div class="coupon_main_container" ng-controller="upitabController">
                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="balance < 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number : '1.0-2'}}
                                    </div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{balance | absolute}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="body_coupon_cash">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 84px;">

                            <div class="amt_container">
                                <div class="amt_card_pg_div" ng-class="{ 'error_border':upiForm.mobile_number.$error.pattern}">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Customer Mobile" formControlName="gatewayCustomerMobileNo">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>

                            <div class="amt_container">
                                <div class="amt_card_pg_div">
                                    <mat-card class="contain_card" style="width: 100%;">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Amount To Pay" formControlName="gatewayAmount" (keyup)="onGatewayAmountChange($event)">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 33px; display: flex; justify-content: space-evenly;">
                                <button *ngIf="pgStatus != 'Payment Successful'" mat-button id="btnn" style="float: left; width: 96%; margin: 0 !important; height: 100%;" (click)="sendGatewayPaymentLink()">Send Request</button>

                                <!-- <button mat-button id="btnn"
                                                style="float: left; width: 48%; margin: 0 !important; height: 100%;" type="button"
                                                (click)="checkGatewayPaymentStatus()">Fetch Reponse</button> -->
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="height: 33px; display: flex; justify-content: space-evenly;margin-top: 4%;">
                                <h4 style="font-size: 16px" [style.color]="pgStatus == 'Payment Initiated' ? '#ef8b09' : pgStatus == 'Payment Successful' ? 'green' : 'red'">
                                    {{pgStatus}}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetSwipe()"> RESET</button>
                        <button *ngIf="pgStatus == 'Payment Successful'" mat-button id="btnn" style="float:right;" (click)="onGatewayPaymentOkClick()">OK</button>
                    </div>
                </div>
            </mat-tab>

            <!-- BANK -->
            <mat-tab label="BANK">
                <ng-template mat-tab-label>
                    <!-- <span class="tab_head">
                                    <img class="img_div_height" async src="./assets/images/chequew.svg" alt="icon" />
                                    <span>BANK ({{total_amt_bank | number : '1.0-2'}})</span>
                                </span> -->

                    <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/chequen.svg" alt="icon" />
                        <!-- <span>BANK</span> -->
                    <span class="img_span">&#8377; {{total_amt_bank | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div class="coupon_main_container" ng-controller="banktabController ">

                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="balance < 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number : '1.0-2'}}
                                    </div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{balance | absolute}}</div>
                                    <!-- <div class="curr_amt_value" *ngIf="refundAmt > 0"
                                                    style="width: 75px !important;padding: 0px !important;"><input
                                                        style="padding-left: 10px !important;" type="number"
                                                        (keyup)="onRefundAmtChange($event)" [value]="refundAmt"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="height: 77%; overflow: auto;">
                        <div class="body_couponBank" formArrayName='bankPayment'>
                            <div *ngFor="let bank of bankPaymentFormArray.controls; let i=index" [formGroupName]="i">
                                <span class="close_icon_span" style="float: left;">
                                    <mat-icon class="close_icon" *ngIf="!bank.show" (click)="bank.show = !bank.show">
                                        keyboard_arrow_up</mat-icon>
                                    <mat-icon class="close_icon" *ngIf="bank.show" (click)="bank.show = !bank.show">
                                        keyboard_arrow_down</mat-icon>
                                </span>
                                <span class="close_icon_span">
                                    <mat-icon class="close_icon" (click)="deleteBank(i)">delete</mat-icon>
                                </span>
                                <fieldset class="field_set" id="security_fieldset" style="padding-top: 20px;">
                                    <div *ngIf="!bank.show">
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Cheque Date" formControlName="chequeDate" [value]="chequeDate" required>
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker disabled="false"></mat-datepicker>
                                            </mat-form-field>
                                        </mat-card>

                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="Bank Name" formControlName="bankName" [value]="bankName">
                                            </mat-form-field>
                                        </mat-card>

                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="Bank Branch" formControlName="bankBranch" [value]="bankBranch">
                                            </mat-form-field>
                                        </mat-card>

                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="IFSC Code" formControlName="ifscCode" [value]="ifscCode">
                                            </mat-form-field>
                                        </mat-card>

                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="Cheque/UTR No" formControlName="chequeNoUTRNo" [value]="chequeNoUTRNo">
                                            </mat-form-field>
                                        </mat-card>

                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="number" matInput placeholder="Amount" formControlName="amount" (keyup)="onBankAmountChange($event)">
                                            </mat-form-field>
                                        </mat-card>
                                    </div>
                                </fieldset>
                            </div>

                            <div class="receipt_bank_container">
                                <div class="bank_detail_container">
                                    <!-- <mat-card class="contain_card" fxFlex="16.6">
                                                <mat-form-field>
                                                    <input type="text" matInput placeholder="Bank Name"
                                                        [value]="bankBankSetup?.bank?.bankName" readonly>
                                                </mat-form-field>
                                            </mat-card>
                                            <mat-card class="contain_card" fxFlex="16.6">
                                                <mat-form-field>
                                                    <input type="text" matInput placeholder="Account Name"
                                                        [value]="bankBankSetup?.bank?.accountName" readonly>
                                                </mat-form-field>
                                            </mat-card>
                                            <mat-card class="contain_card" fxFlex="16.6">
                                                <mat-form-field>
                                                    <input type="text" matInput placeholder="Account Type"
                                                        [value]="bankBankSetup?.bank?.bankAccountType" readonly>
                                                </mat-form-field>
                                            </mat-card>
                                            <mat-card class="contain_card" fxFlex="16.6">
                                                <mat-form-field>
                                                    <input type="number" matInput placeholder="Account No"
                                                        [value]="bankBankSetup?.bank?.bankAccountNo" readonly>
                                                </mat-form-field>
                                            </mat-card>
                                            <mat-card class="contain_card" fxFlex="16.6">
                                                <mat-form-field>
                                                    <input type="text" matInput placeholder="Branch Name"
                                                        [value]="bankBankSetup?.bank?.bankBranchName" readonly>
                                                </mat-form-field>
                                            </mat-card>
                                            <mat-card class="contain_card" fxFlex="16.6">
                                                <mat-form-field>
                                                    <input type="text" matInput placeholder="City"
                                                        [value]="bankBankSetup?.bank?.branchCityName" readonly>
                                                </mat-form-field>
                                            </mat-card> -->
                                    <mat-card class="contain_card" style="height: auto; margin: 6px !important;">
                                        <mat-form-field>
                                            <textarea matInput [value]="'Bank Name: '+bankBankSetup?.bank?.bankName + ',&#13;&#10;' +
                                                            'Account Name: '+bankBankSetup?.bank?.accountName + ',&#13;&#10;' +
                                                            'Account Type: '+bankBankSetup?.bank?.bankAccountType + ',&#13;&#10;' +
                                                            'Account No: '+bankBankSetup?.bank?.bankAccountNo + ',&#13;&#10;' +
                                                            'Branch Name: '+bankBankSetup?.bank?.bankBranchName + ',&#13;&#10;' +
                                                            'City: '+bankBankSetup?.bank?.branchCityName" readonly style="height: 90px;"></textarea>
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetBank()">RESET </button>
                        <button mat-button id="btnn" style="float:right" (click)="onBankPaymentOkClick()">OK</button>
                        <button mat-button id="btnn" style="float:right" (click)="addBank()" [disabled]="bankPaymentFormArray.invalid">ADD
                            BANK</button>
                    </div>
                </div>

            </mat-tab>

            <!-- WALLET -->
            <mat-tab label="WALLET" *ngIf="this.transactionDetailPaymentsDto.customerEmail">
                <ng-template mat-tab-label>
                    <span class="tab_head">
                        <!-- <span>W</span> -->
                    <img class="img_div_height" async src="./assets/images/walletp.svg" alt="icon" width="17" height="20" />
                    <span class="img_span">&#8377; {{total_amt_wallet | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div ng-controller="cashtabController" style="height: 100%" class="ng-scope cashTab" id="cashTab">
                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="balance < 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number : '1.0-2'}}
                                    </div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{balance | absolute}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="height: 77%; overflow: auto;">
                        <div class="body_wallet" style="height: 15% !important;">
                            <div fxLayout="row" fxLayout.lt-sm="row">
                                <mat-card class="contain_card" fxFlex="33">
                                    <mat-form-field>
                                        <input type="number" matInput placeholder="Pay Wallet Balance" (keyup)="onWalletAmtChange($event.target.value)" formControlName="walletAmount" [readonly]="isEditWallet">
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card" fxFlex="33">
                                    <mat-form-field>
                                        <input type="number" matInput placeholder="Useable Amount" [value]="useableWalletBalance" readonly>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card" fxFlex="33">
                                    <mat-form-field>
                                        <input type="number" matInput placeholder="Wallet Balance" [value]="walletBalance" readonly>
                                    </mat-form-field>
                                </mat-card>
                            </div>
                        </div>

                        <div class="body_wallet" style="height: 60% !important;">
                            <mat-grid-list cols="2" rowHeight="265px" gutterSize="5px">
                                <mat-grid-tile>
                                    <mat-card class="mat-card-container">
                                        <mat-card-header class="mat-header">
                                            <mat-card-title class="mat-title">WALLET OFFERS</mat-card-title>
                                        </mat-card-header>
                                        <div style="height: 87%;overflow-y: auto;">
                                            <table class="dashboard-table body-data-style" style="border:1;border-color: black;">
                                                <tr style="height: 10px; background-color: rgba(132,151,176,255)">
                                                    <th class="tr_th">Offer Name</th>
                                                    <th class="tr_th">Amount</th>
                                                    <th class="tr_th">Status</th>
                                                </tr>

                                                <tr *ngFor="let element of offerList" style="background-color: rgba(218,227,243,255);">
                                                    <th class="tr_td">{{element.walletOfferName}}</th>
                                                    <th class="tr_td">{{element.walletAmount}}</th>
                                                    <th class="tr_td" style="text-align: center;color: green;">Offer Applied
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </mat-card>
                                </mat-grid-tile>

                                <mat-grid-tile>
                                    <mat-card class="mat-card-container">
                                        <mat-card-header class="mat-header">
                                            <mat-card-title class="mat-title">WALLET TRANSACTIONS</mat-card-title>
                                        </mat-card-header>
                                        <div style="height: 87%;overflow-y: auto;">
                                            <table class="dashboard-table body-data-style" style="border:1;border-color: black;">
                                                <tr style="height: 10px; background-color: rgba(132,151,176,255)">
                                                    <th class="tr_th">Transaction Id</th>
                                                    <!-- <th class="tr_th">Type</th> -->
                                                    <th class="tr_th">Amount</th>
                                                    <th class="tr_th">Balance</th>
                                                </tr>

                                                <tr *ngFor="let element of walletTransaction" style="background-color: rgba(218,227,243,255);">
                                                    <th class="tr_td">
                                                        <span *ngIf="element.transactionRefNo">{{element.transactionRefNo}}</span>
                                                        <span *ngIf="!element.transactionRefNo">{{element.transactionType}}</span>
                                                    </th>
                                                    <!-- <th class="tr_td">{{element.status}}</th> -->
                                                    <th class="tr_td">
                                                        <span *ngIf="element.status == 'Credit'" style="color: green;">+
                                                            {{
                                                            element.credits }}</span>
                                                        <span *ngIf="element.status != 'Credit'" style="color: red;">-
                                                            {{
                                                            element.credits }}</span>
                                                    </th>
                                                    <th class="tr_td">{{element.balance}}</th>
                                                </tr>
                                            </table>
                                        </div>
                                    </mat-card>
                                </mat-grid-tile>
                            </mat-grid-list>
                        </div>
                    </div>

                    <div class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetWallet()">RESET </button>
                        <button mat-button id="btnn" style="float:right;" *ngIf="!isEditWallet" (click)="onWalletPaymentOkClick()">OK</button>
                    </div>

                </div>
            </mat-tab>

            <!-- PAYTM -->
            <!-- <mat-tab label="PAYTM">
                <div class="coupon_main_container" ng-controller="paytmtabController " ng-show="!disablePage ">
                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label">Balance</div>
                                    <div class="curr_amt_value">&#8377; {{balance}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div formArrayName='paytmPayment' class="body_coupon">
                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <div class="amt_container">
                                <div class="group_amt">

                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Customer Name "
                                                [value]="PaytmCustomerName">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                                <div class="create_customer">
                                    <button mat-button class="create_cust_btn" *ngIf="!isPaytmSelectedCustomer"
                                        (click)="onPaytmSelectCustomerClick()">
                                        <mat-icon class="personadd_icon">person_add</mat-icon>
                                    </button>

                                    <button mat-button class="customer_close" *ngIf="isPaytmSelectedCustomer"
                                        (click)="onRemovePaytmCustomerClick()">
                                        <mat-icon class="white_icon_cancel_customer">close</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div class="amt_container" ng-show="cmobile">
                                <div class="group_amt"
                                    ng-class="{ 'error_border':paytmForm.mobile_number.$error.pattern} ">
                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Customer Mobile "
                                                [value]="PaytmCustomerMobileNo">
                                        </mat-form-field>
                                    </mat-card>

                                </div>
                            </div>

                            <div class="amt_container">
                                <div class="group_amt">
                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="number" matInput placeholder="Amount To Pay "
                                                [value]="paytm_amount_to_pay " (keyup)="onPaytmAmountChange($event) ">
                                        </mat-form-field>
                                    </mat-card>

                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="group_amt">

                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Message/Link Description "
                                                (keyup)="onMessageLinkDescChange($event) ">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>

                        </div>

                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                <span>
                                    <button mat-button class="md-raised md-primary" id="btn-amt-black"
                                        (click)="FetchPayTmPayment() ">Fetch
                                        Payment</button>
                                </span>
                            </div>
                        </div>

                        <div *ngFor="let paytm of paytmPaymentFormArray.controls; let i=index" [formGroupName]="i"
                            class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <div class="amt_container">
                                <div class="group_amt">
                                    <mat-card class="contain_card">
                                        <mat-form-field style="width: 82%;">
                                            <input type="text" matInput placeholder="Status" readonly>
                                        </mat-form-field>
                                        <mat-slide-toggle style="width: 15%">
                                        </mat-slide-toggle>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="group_amt">
                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Order Id"
                                                formControlName="orderId">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="group_amt">
                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Mobile No./Paytm Id"
                                                formControlName="linkId">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="group_amt">
                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Amount" formControlName="amount">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                            <div class="amt_container">
                                <div class="group_amt" id="edit_search_label">
                                    <mat-card class="contain_card">
                                        <mat-form-field>
                                            <input type="text" matInput placeholder="Date">
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bottom_btns_row">
                        <div class="col_6">
                            <div class="amt_container" id="amt_container">
                                <div class="group_amt">
                                    <div class="btn-box">
                                        <button mat-button class="md-raised md-primary" id="btn-amt-black" type="button"
                                            (click)="initiatePayment()">Initiate
                                            Payment</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col_6"></div>
                        <div class="col_6"></div>
                        <div class="col_6"></div>

                        <div class="col_6">
                            <div class="amt_container" id="amt_container">
                                <div class="group_amt">
                                    <div class="btn-box">
                                        <button mat-button class="md-raised md-primary" id="btn-amt-black"
                                            (click)="resetPaytm()">
                                            RESET<mat-icon class="icon-style">settings_backup_restore</mat-icon></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col_6">
                            <div class="amt_container" id="amt_container">
                                <div class="group_amt">
                                    <div class="btn-box">
                                        <button mat-button class="md-raised md-primary" id="btn-amt-black"
                                            (click)="onPaytmPaymentOkClick()">OK</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </mat-tab> -->

            <!-- CARD -->
            <!-- <mat-tab label="CARD">
                <ng-template mat-tab-label>
                    <span class="tab_head">
                        <img class="img_div_height" async src="./assets/images/cardn.svg" alt="icon" />
                        <span class="img_span">&#8377; {{total_amt_card | number : '1.0-2'}}</span>
                    </span>
                </ng-template>
                <div class="coupon_main_container" ng-controller="banktabController">
                    <div class="curr_bal_row">
                        <div class="balance_container">
                            <div class="center-block">
                                <div class="remaining_container">
                                    <div class="curr_amt_label" *ngIf="balance >= 0">Balance</div>
                                    <div class="curr_amt_label" *ngIf="balance < 0">Refund</div>
                                    <div class="curr_amt_value" *ngIf="balance >= 0">&#8377; {{balance | number :
                                        '1.0-2'}}</div>
                                    <div class="curr_amt_value" *ngIf="balance < 0">&#8377; {{balance | absolute}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="height: 77%; overflow: auto;">
                        <div class="body_couponBank" formArrayName='cardPayment'>
                            <div *ngFor="let card of cardPaymentFormArray.controls; let i=index" [formGroupName]="i">
                                <span class="close_icon_span" style="float: left;">
                                    <mat-icon class="close_icon" *ngIf="!card.show"
                                        (click)="card.show = !card.show">keyboard_arrow_up</mat-icon>
                                    <mat-icon class="close_icon" *ngIf="card.show"
                                        (click)="card.show = !card.show">keyboard_arrow_down</mat-icon>
                                </span>
                                <span class="close_icon_span">
                                    <mat-icon class="close_icon" (click)="deleteCard(i)">delete</mat-icon>
                                </span>
                                <fieldset class="field_set" id="security_fieldset" style="padding-top: 20px;">
                                    <div *ngIf="!card.show">

                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input matInput [matDatepicker]="picker3" (click)="picker3.open()"
                                                    placeholder="Date" formControlName="date" readonly>
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="picker3"></mat-datepicker-toggle>
                                                <mat-datepicker #picker3 disabled="false"></mat-datepicker>
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="number" matInput placeholder="Card No."
                                                    formControlName="cardNo">
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="Card Holder Name"
                                                    formControlName="cardHolderName">
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="Bank Name"
                                                    formControlName="bankName">
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <mat-select #department placeholder="Card Type"
                                                    formControlName="cardType">
                                                    <mat-option *ngFor="let card of cardTypes" [value]="card">
                                                        {{card}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="text" matInput placeholder="Transactio Id."
                                                    formControlName="transactionID">
                                            </mat-form-field>
                                        </mat-card>
                                        <mat-card class="contain_card">
                                            <mat-form-field>
                                                <input type="number" matInput placeholder="Amount"
                                                    formControlName="amount" (keyup)="onCardAmountChange()">
                                            </mat-form-field>
                                        </mat-card>

                                    </div>
                                </fieldset>
                            </div>
                            <div class="receipt_bank_container">
                                <div class="bank_detail_container">
                                    <mat-card class="contain_card" style="height: auto; margin: 6px !important;">
                                        <mat-form-field>
                                            <textarea matInput [value]="'Bank Name: '+cardBankSetup?.bank?.bankName + ',&#13;&#10;' +
                                        'Account Name: '+cardBankSetup?.bank?.accountName + ',&#13;&#10;' +
                                        'Account Type: '+cardBankSetup?.bank?.bankAccountType + ',&#13;&#10;' +
                                        'Account No: '+cardBankSetup?.bank?.bankAccountNo + ',&#13;&#10;' +
                                        'Branch Name: '+cardBankSetup?.bank?.bankBranchName + ',&#13;&#10;' +
                                        'City: '+cardBankSetup?.bank?.branchCityName" readonly
                                                style="height: 90px;"></textarea>
                                        </mat-form-field>
                                    </mat-card>
                                </div>
                            </div>

                        </div>


                    </div>

                    <div class="bottom_btns_row">
                        <button mat-button id="btnn" style="float:left;" (click)="resetCard()">RESET </button>
                        <button mat-button id="btnn" style="float:right;" (click)="onCardPaymentOkClick()">OK</button>
                        <button mat-button id="btnn" style="float:right;" (click)="addCard()"
                            [disabled]="cardPaymentFormArray.invalid">ADD
                            CARD</button>
                    </div>
                </div>
            </mat-tab> -->
        </form>
    </mat-tab-group>

    <div style="height: 8%;">
        <button mat-button class="md-raised md-primary" id="btn-amt-black-confirm" (click)="onConfirmClick($event)">
            <span style="display: flex; flex-direction: column; height: 100%;">
                <span style="height: 30%; font-size: 9px;">TOTAL PAID : {{total_amt_byAllTypes | number : '1.0-2'}}
                </span>
                <span style="height: 70%;">CONFIRM</span>
            </span>
        </button>
    </div>
</div>